import DashLayout from "@/layouts/DashLayout";
import PageTitle from "@/components/PageTitle";
import BackLink from "@/components/BackLink";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import { Roles } from "@/redux/services/user/user.type";
import DailyDishes from "@/components/menu/DailyDishes";

const DailyDishesPage = () => {
  return (
    <DashLayout>
      <RoleProtectedPage
        allowedRoles={[Roles.manager, Roles.owner]}
        allowedPermissions={["menu.view"]}
      >
        <div className="space-y-6">
          <div>
            <BackLink to="/menus" label="Retour aux menus" />
            <PageTitle title="Plats du jour" description="Gérez les plats disponibles aujourd'hui" />
          </div>

          <DailyDishes />
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
};

export default DailyDishesPage;
